import api from "./Api";

class TipoUsuarioService {
  GetTipoUsuario(payload) {
    return api.get("/v1/tipousuario/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTipoUsuario(payload) {
    return api.post("/v1/tipousuario/", payload).then((response) => {
      return response.data;
    });
  }

  PutTipoUsuario(payload) {
    return api.put("/v1/tipousuario/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTipoUsuario(payload) {
    return api.delete("/v1/tipousuario/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTipoUsuarioOData(payload) {
    return api.get("/OData/TipoUsuario" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new TipoUsuarioService();
